require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /home/svc.teamcity.prd/BuildAgent/work/80562bb639a6ae70/node_modules/core-js/modules/es6.array.species.js
// module id = Umeq
// module chunks = 8